import Base, { Props } from './Base';

const H1 = Base('h1', theme => ({
  color: (props: Props) => props.color || theme.colors.title,
  fontSize: 36,
}));

const H2 = Base('h2', theme => ({
  color: (props: Props) => props.color || theme.colors.title,
  fontSize: 22,
}));

const H3 = Base('h3', theme => ({
  color: (props: Props) => props.color || theme.colors.title,
  fontSize: 18,
}));

const H4 = Base('h4', theme => ({
  color: (props: Props) => props.color || theme.colors.title,
  fontSize: 14,
  textTransform: 'uppercase',
}));

const P = Base('p', theme => ({
  fontSize: 16,
  fontWeight: (props: Props) => (props.bold ? 700 : 600),
  color: (props: Props) => props.color || theme.colors.bodyText,
}));

const A = Base('a', theme => ({
  color: (props: Props) => props.color || theme.colors.anchor,
  fontWeight: 700,
  cursor: 'pointer',
}));

export { H1, H2, H3, H4, P, A };
